import { Component, Input, OnInit } from "@angular/core"
import { CollectionNode } from "../../../models/collectionNode.model"
import { UserService } from "../../../services/user.service"
import { ModalService } from "../../../shared-components/modal/modal.service"
import Utils from "../../../utils/utils"
import { SocialShareModalComponent } from "../../../shared-components/modals/social-share-modal/social-share-modal.component"
import { STATIC_IMAGES } from "../../../models/constants"
import { combineLatest, Observable, Subject } from "rxjs"
import { PreviewService } from "../../../services/preview.service"
import { takeUntil, tap } from "rxjs/operators"
import { StudentGateService } from "../../../services/student-gate.service"

@Component({
    selector: "app-collection-heading",
    templateUrl: "./collection-heading.component.html",
    styleUrls: ["./collection-heading.component.scss"],
    standalone: false,
})
export class CollectionHeadingComponent implements OnInit {
    @Input() collection: CollectionNode = null

    googleClassroomImage: string = STATIC_IMAGES.google_classroom_x48_yellow_stroke_icon
    isShortDescDisplayed: boolean = true
    isInPreviewMode$: Observable<boolean>
    isStudent: boolean = false
    public selectedGrade: string = ""
    private destroyed$: Subject<void> = new Subject<void>()

    studentToggleObservable: Observable<[string, string]> = combineLatest([
        this.studentGateService.collectionFilterChoice,
        this.studentGateService.selectedGradeState,
    ]).pipe(
        takeUntil(this.destroyed$),
        tap(([collectionFilter, selectedGrade]: [string, string]) =>
            this.setMessageGrade(collectionFilter, selectedGrade)
        )
    )

    constructor(
        private modalService: ModalService,
        public userService: UserService,
        private studentGateService: StudentGateService,
        private previewService: PreviewService
    ) {}

    ngOnInit() {
        this.isInPreviewMode$ = this.previewService.previewOnCollection$
        this.studentToggleObservable.subscribe()
        this.isStudent = this.userService.hasStudentExperience()
    }

    setMessageGrade(collectionFilter: string, selectedGrade: string) {
        this.selectedGrade = collectionFilter === "All grades" ? "All grades" : selectedGrade
    }

    public shareWithGoogleClassroom() {
        Utils.shareLinkToGC()
    }

    public openShareModal() {
        this.modalService.open(SocialShareModalComponent, {
            data: {
                titleToShare: this.collection.title,
            },
        })
    }

    public hasFeaturedAsset(): boolean {
        return !!this.collection.featuredAsset.mediaType
    }

    public get isLoading(): boolean {
        return !this.collection?.resources?.length
    }

    get isParenCollectionWithChildren() {
        return !window.location.pathname.includes("/t/") && this.collection.children.length > 0
    }
    public hasCollectionLoaded() {
        return this.collection.id
    }
}
